type Callback = (...args: unknown[]) => unknown;
type Subscription = {
  unsubscribe: () => void;
};

export const EV_EM_SUBSCRIPTION_KEY = {
  COINS_BALANCE_INCREASE: 'coins_balance_increase',
};

class EventEmitter {
  subscriptions: Record<string, Callback[]> = {};

  subscribe(eventName: string, callback: Callback): Subscription {
    if (this.subscriptions[eventName] === undefined) {
      this.subscriptions[eventName] = [];
    }

    this.subscriptions[eventName].push(callback);

    return {
      unsubscribe: () => {
        if (this.subscriptions[eventName].length > 1) {
          this.subscriptions[eventName] = this.subscriptions[eventName].filter(
            (f) => f !== callback,
          );
        } else {
          delete this.subscriptions[eventName];
        }
      },
    };
  }

  emit(eventName: string, args: unknown[] = []): unknown[] {
    if (!(eventName in this.subscriptions)) return [];
    return this.subscriptions[eventName].map((f) => f(...args));
  }
}

export const eventEmitter = new EventEmitter();
